import React from 'react';

import Img from '../../Img';

import styles from './checkBox.scss';

const CheckBoxBase = (props) => {
    const {
        inputProps,
        onChange,
        customLabel,
        customLabelClass,
        checked,
        disabled,
        wrapperCssClass,
        'data-testid': dataTestId,
    } = props;
    return (
        <div className={`${wrapperCssClass}`}>
            <input
                {...inputProps}
                data-testid={dataTestId || undefined}
            />
            <div>
                <label>
                    <div className={`${styles.customCheckBox}`}>
                        <span
                            className={`${styles.customCheckIcon} ${disabled ? styles.disabled : ''} ${checked ? styles.checked : ''}`}
                            onClick={onChange ? (ev) => onChange(!checked, ev) : null}
                            data-testid={dataTestId && `${dataTestId}.check-icon`}
                        >
                            {checked && <Img src="/img/icons/checkmark-icon.svg" />}
                        </span>
                        <span
                            className={`${styles.customCheckLabel} ${disabled ? styles.disabled : ''} ${customLabelClass}`}
                            onClick={onChange ? (ev) => onChange(!checked, ev) : null}
                            data-testid={dataTestId && `${dataTestId}.label`}
                        >
                            {customLabel}
                        </span>
                    </div>
                </label>
            </div>
        </div>
    );
};

export default CheckBoxBase;
